function tabRefresh(className){
  $(className).slick({
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 300,
    slidesToScroll: 4,
    slidesToShow: 4,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.81873 12.7142L0.901305 6.99993L6.81873 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.846375 12.7142L6.7638 6.99993L0.846375 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
}

$(document).ready(function () {
  $(document).on("click", ".collectionTrigger", function () {
    $(".collectionTrigger").removeClass("active");
    $(this).addClass("active");
    var collectioHandle = $(this).data("collection-handle");
    var sectionId = $(this).data("section-id"),
      products_to_show = $(this).data("products_to_show"),
      media_size = $(this).data("media_size"),
      show_secondary_image = $(this).data("show_secondary_image"),
      show_quick_buy = $(this).data("show_quick_buy"),
      show_vendor = $(this).data("show_vendor"),
      show_rating = $(this).data("show_rating"),
      enable_quick_view = $(this).data("enable_quick_view"),
      enable_color_swatches = $(this).data("enable_color_swatches"),
      enable_countdown = $(this).data("enable_countdown"),
      enable_image_fill = $(this).data("enable_image_fill");
    // console.log(`/collections/${collectioHandle}/?section_id=tabbed-featured-collection&products_to_show=${products_to_show}&media_size=${media_size}&show_secondary_image=${show_secondary_image}&show_quick_buy=${show_quick_buy}&show_vendor=${show_vendor}&show_rating=${show_rating}&enable_quick_view=${enable_quick_view}&enable_color_swatches=${enable_color_swatches}&enable_countdown=${enable_countdown}&enable_image_fill=${enable_image_fill}`)
    if (collectioHandle != "") {
      $.ajax({
        url: `/collections/${collectioHandle}/?section_id=tabbed-featured-collection&products_to_show=${products_to_show}&media_size=${media_size}&show_secondary_image=${show_secondary_image}&show_quick_buy=${show_quick_buy}&show_vendor=${show_vendor}&show_rating=${show_rating}&enable_quick_view=${enable_quick_view}&enable_color_swatches=${enable_color_swatches}&enable_countdown=${enable_countdown}&enable_image_fill=${enable_image_fill}`,
        method: "GET",
        dataType: "html",
      })
      .done(function (responseText) {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        var sliderElement = $(responseHTML).find(".itg-hidden-tabs-product").prop("innerHTML");
        $(document).find('.TabbedFeaturedCollection[data-section-id="' + sectionId + '"]').html(sliderElement);
        var thisSlider = $(document).find('.TabbedFeaturedCollection[data-section-id="' + sectionId + '"]').find('.featured_collection_slider');
        tabRefresh(thisSlider);
      })
      .fail(function (jqXHR, textStatus, errorThrown) {});
    }
  });
  
  tabRefresh('.featured_collection_slider');
  $(".banner_slider").slick({
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.81873 12.7142L0.901305 6.99993L6.81873 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.846375 12.7142L6.7638 6.99993L0.846375 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  });

   setTimeout(function () {
    $(".banner_slider").slick("refresh");
  }, 2500);
  $(window).resize(function(){
    $(".banner_slider").slick("refresh");
  });
  $(".logo_slider").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 300,
    slidesToScroll: 4,
    slidesToShow: 5,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.81873 12.7142L0.901305 6.99993L6.81873 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.846375 12.7142L6.7638 6.99993L0.846375 1.28564' stroke='#1F2126' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
  $(".itg_drawer_open").click(function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_sample_order").css(css_property).css("visibility", "visible");
  });
  $(".itg_drawer_close,.drawerOverlay").click(function () {
    $(".itg_sample_order")
      .css("opacity", "0")
      .css("right", "-500px")
      .css("visibility", "hidden");
  });

  $(".itg_matching_open").click(function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_matching_order").css(css_property).css("visibility", "visible");
  });
  $(".itg_drawer_close,.drawerOverlay").click(function () {
    $(".itg_matching_order")
      .css("opacity", "0")
      .css("right", "-500px")
      .css("visibility", "hidden");
  });

  $(".relatedDrawerTrigger").click(function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_more_variant").css(css_property).css("visibility", "visible");
  });
  $(".itg_drawer_close,.drawerOverlay").click(function () {
    $(".itg_more_variant")
      .css("opacity", "0")
      .css("right", "-500px")
      .css("visibility", "hidden");
  });

  $(".calcDrawerbtn").click(function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_drawercalc").css(css_property).css("visibility", "visible");
  });
  $(".itg_drawer_close ,.drawerOverlay").click(function () {
    $(".itg_drawercalc")
      .css("opacity", "0")
      .css("right", "-500px")
      .css("visibility", "hidden");
  });
  // variant description change
  var selectedALt = $(
    ".product-form__input input[type=radio]:checked+label img"
  ).attr("alt");
  var imglen = $(
    '.template-product .product__media-item[alt="' + selectedALt + '"]'
  ).length;
  if (imglen >= 1) {
    $(".template-product .itg_mergeVariant  .thumbnail-list__item").hide();
    $(".template-product .itg_mergeVariant  .product__media-item").removeClass(
      "is-active"
    );
    $(
      '.template-product .itg_mergeVariant  .product__media-item[alt="' +
        selectedALt +
        '"]'
    )
      .first()
      .addClass("is-active");
    $(
      '.template-product .itg_mergeVariant  .thumbnail-list__item[alt="' +
        selectedALt +
        '"]'
    )
      .first()
      .attr("aria-current", true);
    $(
      '.template-product .itg_mergeVariant  .thumbnail-list__item[alt="' +
        selectedALt +
        '"]'
    ).show();
  } else {
    $(".template-product .itg_mergeVariant  .thumbnail-list__item").show();
    $(".template-product .itg_mergeVariant  .product__media-item")
      .first()
      .addClass("is-active");
  }

  $(document).on(
    "change",
    ".product-form__input input[type=radio]",
    function () {
      var selectedVariant = $(this).attr("data-index");
      $(".itg_more_variant")
        .css("opacity", "0")
        .css("right", "-500px")
        .css("visibility", "hidden");
      var selectedALt = $(this)
        .closest(".product-form__input")
        .find("input[type=radio]:checked+label img")
        .attr("alt");

      //$('.variantDescription').hide();
      //$('.variantDescription[title="'+selectedVariant+'"]').show();
      var imglen = $(
        '.template-product .itg_mergeVariant  .product__media-item[alt="' +
          selectedALt +
          '"]'
      ).length;
      if (imglen >= 1) {
        $(".template-product .itg_mergeVariant  .thumbnail-list__item").hide();
        $(
          ".template-product .itg_mergeVariant .product__media-item"
        ).removeClass("is-active");
        $(
          '.template-product .itg_mergeVariant  .product__media-item[alt="' +
            selectedALt +
            '"]'
        )
          .first()
          .addClass("is-active");
        $(
          '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
            selectedALt +
            '"]'
        )
          .first()
          .attr("aria-current", true);
        $(
          '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
            selectedALt +
            '"]'
        ).show();
      } else {
        $(".template-product .itg_mergeVariant  .thumbnail-list__item").show();
        $(".template-product .itg_mergeVariant  .product__media-item")
          .first()
          .addClass("is-active");
      }
    }
  );
  // Product-page-calculator

  const selectors = {
    input: ".itg_drawercalc input",
    boxval: ".itg_calcContent",
  };

  function calculateArea() {
    $(document).find("#boxes_required").text("");
    $(document).find("#sq_ft_included").text("");
    $(document).find("#box_width").val("");
    $(document).find("#box_length").val("");
    var lengthdata = 0;
    var widthdata = 0;
    var final_len_width = 0;
    var total_sq_fit = 0;
    var box_price = 0;
    var waste_per = "";

    var len_popup_feet = parseFloat(
      $(selectors.input + "#len_popup_feet").val() || 0
    );

    var len_popup_inch = parseFloat(
      $(selectors.input + "#len_popup_inch").val() || 0
    );

    var width_popup_feet = parseFloat(
      $(selectors.input + "#width_popup_feet").val() || 0
    );

    var width_popup_inch = parseFloat(
      $(selectors.input + "#width_popup_inch").val() || 0
    );

    var waste_percentage = parseFloat(
      $(selectors.input + "#waste_per").val() || 0
    );

    var product_price = parseFloat(
      $(selectors.boxval).attr("product-price") || 0
    );

    var box_price = parseFloat($(selectors.boxval).attr("data-box") || 0);

    var lengthdata = len_popup_feet * 12 + len_popup_inch;

    var widthdata = width_popup_feet * 12 + width_popup_inch;

    // Total Square Footage
    var final_len_width = lengthdata * widthdata;
    var total_sq_fit = final_len_width / 144;
    var total_sq_fit = total_sq_fit.toFixed(2);

    $(document).find("#sq_ft_included").text(total_sq_fit);
    $(document).find("#box_width").val(total_sq_fit);

    // Square Per Box
    //var sqr_per_box = (product_price/box_price);
    var sqr_per_box = total_sq_fit / box_price;
    var sqr_per_box = sqr_per_box.toFixed(2);

    // Number of Cartons(Box)
    //var total_sqr_box = (parseFloat(total_sq_fit)/parseFloat(sqr_per_box));
    //var total_sqr_box = total_sqr_box.toFixed(2);
    //console.log('total_sqr_box:'+total_sqr_box);
    $(document).find("#boxes_required").text(sqr_per_box);
    
    $(document).find("#box_length").val(sqr_per_box);
  //  console.log(sqr_per_box)
    var sqr_per_boxNew = Math.round(sqr_per_box);
    if(sqr_per_boxNew > 0){
       $(document).find('.quantity__input').val(sqr_per_boxNew)
    }else{
         $(document).find('.quantity__input').val('1')
 
    }

    // Total Percentage Waste
    if (waste_percentage != 0) {
      var waste_per = (parseFloat(sqr_per_box) * waste_percentage) / 100;
      var waste_per = parseFloat(sqr_per_box) + parseFloat(waste_per);
      var waste_per = waste_per.toFixed(2);
      $(document).find("#boxes_required").text("");
      $(document).find("#box_length").val("");
      $(document).find("#boxes_required").text(waste_per);
      $(document).find("#box_length").val(waste_per);
       var sqr_per_boxNew = Math.round(waste_per);
      if(sqr_per_boxNew > 0){
         $(document).find('.quantity__input').val(sqr_per_boxNew)
      }else{
           $(document).find('.quantity__input').val('1')
      }
    }
    if (waste_percentage != 0) {
      var waste_per = (parseFloat(total_sq_fit) * waste_percentage) / 100;
      var waste_per = parseFloat(total_sq_fit) + parseFloat(waste_per);
      var waste_per = waste_per.toFixed(2);
      $(document).find("#sq_ft_included").text("");
      $(document).find("#box_width").val("");
      $(document).find("#sq_ft_included").text(waste_per);
      $(document).find("#box_width").val(waste_per);
    }

    // Number of Cartons
    var number_of_cartons = parseFloat(waste_per) / parseFloat(sqr_per_box);
    var number_of_cartons = number_of_cartons.toFixed(2);
  }
  $(selectors.input).on("keyup", function () {
    calculateArea();
  });

  var get_id = $(document).find("#get_id").val();
  if (get_id != "" && get_id != undefined) {
    $(document).find(".itg_calcContent").attr("data-box", "");
    $(document).find(".itg_calcContent").attr("product-price", "");
    // $(document).find("#sq_ft_price").text('');
    $(document).find("#ItgBoxCount").attr("data-itg", "");
    $("#custom_varaint_sel > option").each(function () {
      var ths_id = $(this).val();
      if (ths_id == get_id) {
        var ths_price = parseFloat($(this).attr("data-price"));
        var ths_sqft = parseFloat($(this).attr("data-sq"));
        var ths_suffix = $(this).attr("price-suffix");
        var unitPriceSuffix = $(this).attr("unit-price-suffix");
        if (isNaN(ths_sqft)) {
        } else {
          var sqr_per_box = ths_price / ths_sqft;
          var sqr_per_box = sqr_per_box.toFixed(2);
          $(document)
            .find("#sq_ft_price")
            .text("$" + sqr_per_box + unitPriceSuffix);
          //  $(document).find("#sq_ft_price").text('$'+sqr_per_box+'/Sq.Ft.');
          $(document).find(".itg_calcContent").attr("data-box", ths_sqft);
          $(document).find(".itg_calcContent").attr("product-price", ths_price);
          $(document).find("#ItgBoxCount").attr("data-itg", ths_sqft);
        }
      }
    });
  }

  $(document).on(
    "click",
    "fieldset.product-form__input.variant-input-wrapper label",
    function () {
      $(".variantDescription").hide();
      setTimeout(function () {
        var get_id = $(document).find("#get_id").val();
        $(document).find(".itg_calcContent").attr("data-box", "");
        $(document).find(".itg_calcContent").attr("product-price", "");
        $(document).find("#sq_ft_price").text("");
        $(document).find("#ItgBoxCount").attr("data-itg", "");

        $(".variantDescription").each(function () {
          var ths_id = $(this).attr("dataid");
          if (ths_id == get_id) {
            $(this).show();
          }
        });

        var selectedALt = $(
          '#custom_varaint_sel > option[value="' + get_id + '"]'
        ).attr("imagealt");
        //$('.variantDescription').hide();
        //$('.variantDescription[title="'+selectedVariant+'"]').show();
        var imglen = $(
          '.template-product .itg_mergeVariant  .product__media-item[alt="' +
            selectedALt +
            '"]'
        ).length;
        if (imglen >= 1) {
          $(
            ".template-product .itg_mergeVariant  .thumbnail-list__item"
          ).hide();
          $(
            ".template-product .itg_mergeVariant .product__media-item"
          ).removeClass("is-active");
          $(
            '.template-product .itg_mergeVariant  .product__media-item[alt="' +
              selectedALt +
              '"]'
          )
            .first()
            .addClass("is-active");
          $(
            '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
              selectedALt +
              '"]'
          )
            .first()
            .attr("aria-current", true);
          $(
            '.template-product .itg_mergeVariant .thumbnail-list__item[alt="' +
              selectedALt +
              '"]'
          ).show();
        } else {
          $(
            ".template-product .itg_mergeVariant  .thumbnail-list__item"
          ).show();
          $(".template-product .itg_mergeVariant  .product__media-item")
            .first()
            .addClass("is-active");
        }
        $("#custom_varaint_sel > option").each(function () {
          var ths_id = $(this).val();
          if (ths_id == get_id) {
            var ths_price = parseFloat($(this).attr("data-price"));
            var ths_sqft = parseFloat($(this).attr("data-sq"));
            var sqr_per_box = ths_price / ths_sqft;
            var unitPriceSuffix = $(this).attr("unit-price-suffix");
            console.log(ths_price, ths_sqft, sqr_per_box);
            if (isNaN(ths_sqft)) {
            } else {
              var sqr_per_box = sqr_per_box.toFixed(2);
              // $(document).find("#sq_ft_price").text('$'+sqr_per_box+'/Sq.Ft.');
              $(document)
                .find("#sq_ft_price")
                .text("$" + sqr_per_box + unitPriceSuffix);
              $(document)
                .find(".sqfitBox")
                .text("(" + ths_sqft + " Sq. Ft. Per Box)");
              $(document).find(".itg_calcContent").attr("data-box", ths_sqft);
              $(document)
                .find(".itg_calcContent")
                .attr("product-price", ths_price);
              $(document).find("#ItgBoxCount").attr("data-itg", ths_sqft);
            }
          }
        });
      }, 800);
    }
  );

  $("#box_width").on("keyup change", function () {
    var ths_width = $(this).val();
    var ths_meta = $("#ItgBoxCount").attr("data-itg");
    if (ths_width != "") {
      $(document).find("#box_length").val("");
      var itgfinal = parseFloat(ths_width) / parseFloat(ths_meta);
      var itgfinal = itgfinal.toFixed(2);
      var Newitgfinal = Math.round(itgfinal);
      var itgqut = Math.ceil(itgfinal);
      $(document).find("#box_length").val(itgfinal);
      if(Newitgfinal > 0){
         $(document).find('.quantity__input').val(Newitgfinal)
      }else{
           $(document).find('.quantity__input').val('1')
      }
      
    } else {
      $(document).find("#box_length").val("");
    }
  });

  $("#box_length").on("keyup change", function () {
    var ths_width = $(this).val();
    var ths_meta = $("#ItgBoxCount").attr("data-itg");
    if (ths_width != "") {
      $(document).find("#box_width").val("");
      var itgfinal = parseFloat(ths_width) / parseFloat(ths_meta);
      var itgfinal = itgfinal.toFixed(2);
      $(document).find("#box_width").val(itgfinal);
    } else {
      $(document).find("#box_width").val("");
    }
  });

  $(".faqDrawerbtn").click(function () {
    var css_property = {
      right: 0,
      opacity: 1,
    };
    $(".itg_drawerfaq").css(css_property).css("visibility", "visible");
  });
  $(".itg_drawer_close").click(function () {
    $(".itg_drawerfaq")
      .css("opacity", "0")
      .css("right", "-500px")
      .css("visibility", "hidden");
  });
  // $(".cstmAddTocart").submit(function (e) {
  //   e.preventDefault(); // avoid to execute the actual submit of the form.
  //   var form = $(this);
  //   var actionUrl = form.attr("action");
  //   $.ajax({
  //     type: "POST",
  //     url: actionUrl,
  //     data: form.serialize(),
  //     success: function (data) {
  //       alert("Sample Product added to Cart");
  //       setTimeout(function () {
  //         $.getJSON("/cart.js", function (cart) {
  //           var result = cart.item_count;
  //           $(".cart-count-bubble").find("span").first().text(result);
  //         });
  //       }, 300);
  //     },
  //   });
  // });
  $("#articleSearchField").keyup(function () {
    var sSearch = this.value;
    $(".ITGArticle").hide();

    var len = $('.ITGArticle:contains("' + sSearch + '")').length;
    if (len > 0) {
      $(".artclebox").show();
      $('.ITGArticle:contains("' + sSearch + '")').show();
    } else {
      $(".artclebox").hide();
    }
    if (sSearch == "") {
      $(".artclebox").hide();
      $(".ITGArticle").hide();
    }
  });
  // selected variant options show on matching molding drawer
$(document).on('click', '.itg_matching_open', function(){
    var itg_matching_molding_var = $('.product-form__input.variant-input-wrapper[data-option-index="option1"] input[type="radio"]:checked').attr('data-value');
    $(document).find('.itg_matching_order ul li').removeClass('active');
      $(document).find('.itg_matching_order li[data-variant-title="'+itg_matching_molding_var+'"]').addClass('active');
  });

  $(document).on('click', '.itg_variant_image', function(){
    var varItemId = $(this).find('.Itgvariantimage img').attr('data-id');
    console.log(varItemId);
    $(this).closest('.product').find('.product-labels .product_var_lbls .product_var_lbls_bx').each(function () {
      var varId = $(this).attr('data-varId');
      if (varItemId == varId){
          $(this).show();
      }else{
          $(this).hide();
      }
    });
  });
  
  var varItem = $('.variant-input-wrapper').find('input:checked+label.itg_variant_image').find('.Itgvariantimage img').attr('data-id');
  $('.product').find('.product-labels .product_var_lbls .product_var_lbls_bx').each(function () {
    var varLbId = $(this).attr('data-varId');
    if (varItem == varLbId){
        $(this).show();
    }else{
        $(this).hide();
    }
  });
});
